import dayjs from 'dayjs';
import humanizeDuration from 'humanize-duration';

// ----------------------------------------------------------------------

export function fDate(date: Date | string | number) {
  return dayjs(date).format('DD/MM/YYYY');
}

export function fFullDateTime(date: Date | string | number) {
  return dayjs(date).format('DD MMM YYYY HH:mm:ss');
}

export function fMonthYearDate(date: Date | string | number) {
  return dayjs(date).format('MMM YYYY');
}

export const shortEnglishHumanizer = humanizeDuration.humanizer({
  language: "shortEn",
  languages: {
    shortEn: {
      y: () => "y",
      mo: () => "mo",
      w: () => "w",
      d: () => "d",
      h: () => "h",
      m: () => "m",
      s: () => "s",
      ms: () => "ms",
    },
  },
  spacer: '',
});
